module.exports = __webpack_public_path__ + "assets/img/item1.43e50f40.jpg";